import { IconShare } from './QuirkIcons';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './SettingsMenu.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import desktopStyles from './SettingsMenuDesktop.module.css';
import { useShare } from '../hooks/useShare';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';

interface ShareTypes {
	label?: string;
	gutter?: boolean;
}

export const Share: React.FC<ShareTypes> = ({ label, gutter }) => {
	const { data: siteSettings } = useGetPublicInformationQuery();
	const origin = window.location.origin;
	const signupUrl = origin + '/signup';
	const message = `Experience ${siteSettings?.siteName} - the all-in-one app for hyperlocal news and events, with a comprehensive business directory. Try it now to explore what your community has to offer: ${signupUrl}`;
	const { handleShare } = useShare({ message });
	return (
		<div className={gutter ? desktopStyles.menuItemContainer : styles.menuItemContainer} onClick={handleShare}>
			<IconShare />

			<div className={gutter ? desktopStyles.menuItemLabel : styles.menuItemLabel}>
				{label || `Invite a friend to ${siteSettings?.siteName}`}
			</div>
		</div>
	);
};
